import { Injectable } from "@angular/core";
import { CanActivate } from "@angular/router";
import { CookieNames, JeanologiaNgSsoauthService } from "@jeanologia/ng-ssoauth";

/**
 * Garantiza que exista la cookie `jean-api`. Si el usuario llega con una sesión
 * de otra app (p.ej. v2: login + data-v2 pero SIN jean-api), fuerza el login
 * contra el login server de esta app para que se genere la cookie jean-api.
 */
@Injectable({
	providedIn: "root",
})
export class JeanApiGuard implements CanActivate {
	constructor(private ssoauth: JeanologiaNgSsoauthService) {}

	public canActivate(): boolean {
		const jeanApi = this.ssoauth.getCookie(CookieNames.JEANAPI);

		if (!jeanApi || !jeanApi.token) {
			// No hay jean-api -> fuerza login y vuelve a esta misma URL.
			this.ssoauth.redirect(window.location.href);
			return false;
		}

		return true;
	}
}
